// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1Sg28","head":"ProcedureTableInfo_head__1H-Kv"};